import { ProgramV2 } from 'frontend/types'
import { Plugin } from '../../types'

export interface NextEpisode extends Partial<ProgramV2> {
  accessibleEpisodes: ProgramV2[]
  slug: string
}

export const AUTOSTART_PARAM = 'autostart=true'

const nextEpisodeOverlay = (
  setShowOverlay: (showOverlay: boolean) => void,
  accessibleEpisodes: ProgramV2[],
  isSingle: boolean,
  productId: number,
): Plugin => {
  return (jwPlayer: jwplayer.JWPlayer) => {
    const doesNotHaveEpisodes = isSingle || accessibleEpisodes.length === 0
    if (doesNotHaveEpisodes) return

    const lastEpisode = accessibleEpisodes[accessibleEpisodes.length - 1]
    const isLastEpisode = productId === lastEpisode.id

    jwPlayer.on('complete', () => {
      if (!isLastEpisode) {
        setShowOverlay(true)
      }
    })
    jwPlayer.on('play', () => {
      if (!isLastEpisode) {
        setShowOverlay(false)
      }
    })
  }
}

export default nextEpisodeOverlay
